import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { stores } from "../../../../../../redux/stores/action";
import { selectStoresListItems } from "../../../../../../redux/stores/selector";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";

const ManagementStores = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
    const storeItems = useSelector(selectStoresListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'StoreInfo.StoreName', headerName: 'Store Name' },
      { field: 'StoreInfo.StorePhoneNumber', headerName: 'Store PhoneNumber' },
      { field: 'StoreInfo.CountryCode', headerName: 'Country Code' },
      { field: 'StoreInfo.CurrencyCode', headerName: 'Currency Code' },
      { field: 'StoreInfo.SslEnabled', headerName: 'SslEnabled', cellRenderer: 'yesNoRenderer' },
      { field: 'StoreInfo.IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer' }
      
        ]);
      }
      const fetchStores=()=>{

      	dispatch(stores.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/stores/list`,entity:'stores',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchStores()
	}, [pageData])
  const additionButtons: any = [
    {
      name: 'Go To Store Channels',
      callback: () => handleStoreChannels(),
    },
    {
      name: 'Go To Pickup Points',
      callback: () => handlePickupPoints(),
    }
  ];
  const handlePickupPoints=()=>{
    navigate('/management/organization/organization-management/stores/pickup-points')
  }
  const handleStoreChannels=()=>{
    navigate('/management/organization/organization-management/channels')
  }
  const handleEdit=(data: any)=>{
    navigate(`${data?.StoreInfo?.Id}`)
  }

const handleDelete=(data: any)=>{
} 
	return (
    <>
    {storeItems?.isLoading ? 
    <PageLoader />
    :   
		<Table columnData={columnDefs} rowData={storeItems?.result?.items}  setPageData={setPageData}
    paginationData={storeItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Stores"  />
  }
  </> 
     
	);
};

export default ManagementStores;


